export const EnVideoStrings = {
  NO_ACTIVE_STREAMS: "No Active Live Streams"
}